module.exports = __webpack_public_path__ + "static/media/itunes-app-store-logo@2x.4b899c73.png";